var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text !== null)?_c('div',{staticClass:"box"},[_c('div',{staticClass:"b-1"},[_c('div',[_c('h5',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.app_name))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})])]),_c('div',{staticClass:"b-2"},[_c('img',{attrs:{"width":"150px","src":_vm.logo_url,"alt":"logo"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }